import { useSelector } from "react-redux";
import React from "react";
import { getCloudOrgStructureElement } from "slices/cloudOrgStructure";
import { Box } from "@mui/material";
import { createLookupRegistry, useLookupOnce } from "common/useLookupOnce";

const registry = createLookupRegistry();

const NiceSubscription = (props) => {
  const wantedResource = props.children;
  const isBillingAccount = wantedResource === "billingAccount";

  const subscription = useSelector((state) =>
    state.cloudOrgStructure?.data?.list?.find((org) => org.id === wantedResource)
  );

  useLookupOnce(
    registry,
    wantedResource,
    (id) => getCloudOrgStructureElement({ id }),
    { resolved: !!subscription, skip: isBillingAccount }
  );

  if (isBillingAccount) {
    //special case just return a nice name
    return <Box>Billing Account</Box>;
  }

  return (
    <>{subscription ? <Box>{subscription.name}</Box> : <Box>{wantedResource}</Box>}</>
  );
};

export default React.memo(NiceSubscription);
